import { type ForwardedRef, forwardRef, type CSSProperties } from 'react';

import Input from './input.js';

interface FiatAssetInputProps {
  value?: string;
  loading?: boolean;
  className?: string;
  style?: CSSProperties;
  onBlur?: () => void;
  onFocus?: () => void;
  onChangeText?: (value: string) => void;
  disabled?: boolean;
}

function FiatAssetInput(
  {
    value,
    loading,
    className,
    style,
    onBlur,
    onFocus,
    onChangeText,
    disabled,
  }: FiatAssetInputProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <Input
      ref={ref}
      disabled={disabled}
      value={value ? `$${value}` : undefined}
      loading={loading}
      placeholder="$0"
      fieldSizing="content"
      className={className}
      height={13}
      monospace
      style={style}
      onBlur={onBlur}
      onFocus={onFocus}
      onChangeText={onChangeText}
      dataTestId="fiat-asset-input"
    />
  );
}

const FiatAssetInputWithForwardedRef = forwardRef(FiatAssetInput);

export const DisabledFiatAssetInput = forwardRef(
  (props: FiatAssetInputProps, ref: ForwardedRef<HTMLInputElement>) => (
    <FiatAssetInputWithForwardedRef ref={ref} {...props} disabled />
  ),
);

export default FiatAssetInputWithForwardedRef;
